<button type="button" (click)="tryExample()" class="flex flex-row items-center text-slate-500 text-xxxs underline">
  <img ngSrc="/assets/images/icons/repeat.svg" alt="Try example" height="16" width="16" class="mr-1" />
  Try example
</button>
